var _effectorFileName = "/builds/gmini/front-common/src/forge-viewer/model/themeModel.ts";
import { createEvent, forward, sample } from 'effector';
import { loadedModels$, removeLoadedModel, updateLoadedModels } from "./loadedModel";
export var Color;

(function (Color) {
  Color["GREEN"] = "GREEN";
  Color["RED"] = "RED";
  Color["YELLOW"] = "YELLOW";
  Color["GRAY"] = "GRAY";
  Color["WHITE"] = "WHITE";
})(Color || (Color = {}));

export function createViewerColoredModel() {
  var colorViewerElements = createEvent({
    name: "colorViewerElements",
    sid: "ry4er8"
  });
  var modelLoaded = createEvent({
    name: "modelLoaded",
    sid: "-greweq"
  });
  var modelRemoved = createEvent({
    name: "modelRemoved",
    sid: "84zlim"
  });
  sample({
    ɔ: [{
      clock: updateLoadedModels,
      source: loadedModels$,
      fn: function fn(loadedModels, loadedModel) {
        return {
          loadedModel: loadedModel,
          loadedModels: loadedModels
        };
      }
    }],
    config: {
      sid: "qodtz8"
    }
  }).watch(function (_ref) {
    var loadedModel = _ref.loadedModel,
        loadedModels = _ref.loadedModels;

    if (loadedModel.status === 'Finished' && loadedModels[loadedModel.urn]) {
      modelLoaded({
        urn: loadedModel.urn
      });
    }
  });
  forward({
    ɔ: {
      from: removeLoadedModel,
      to: modelRemoved
    },
    config: {
      sid: "r4vns2"
    }
  });
  return {
    modelLoaded: modelLoaded,
    modelRemoved: modelRemoved,
    colorViewerElements: colorViewerElements
  };
}